import { useEffect, useLayoutEffect, type ReactNode } from 'react';

const useIsomorphicLayoutEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect;

const LockBody = ({ children }: { children: ReactNode }) => {
  useIsomorphicLayoutEffect(() => {
    const original = {
      overflow: document.body.style.overflow,
      position: document.body.style.position,
      touchAction: document.body.style.touchAction,
      paddingRight: document.body.style.paddingRight,
    };

    const style = getComputedStyle(document.body);
    const offsetX =
      parseInt(style.marginRight) +
      parseInt(style.paddingRight) +
      parseInt(style.borderRight) +
      parseInt(style.marginLeft) +
      parseInt(style.paddingLeft) +
      parseInt(style.borderLeft);

    const scrollBarWidth = window.innerWidth - document.body.offsetWidth - offsetX;
    document.documentElement.style.setProperty('--pcm-scrollbar-width', `${scrollBarWidth}px`);

    document.body.style.overflow = 'hidden';
    document.body.style.position = 'relative';
    document.body.style.touchAction = 'none';

    return () => {
      document.documentElement.style.removeProperty('--pcm-scrollbar-width');

      document.body.style.overflow = original.overflow;
      document.body.style.position = original.position;
      document.body.style.touchAction = original.touchAction;
    };
  }, []);

  return <>{children}</>;
};

export default LockBody;
